const STORAGE_KEY = "inchat-trainer-projects";

function readTrainerProjectHints() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}

export function markTrainerProjectHint(gameId) {
  if (!gameId) return;

  const id = String(gameId);
  const hints = readTrainerProjectHints();
  if (hints.includes(id)) return;

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...hints, id]));
}

export function isTrainerProjectHint(gameId) {
  if (!gameId) return false;
  return readTrainerProjectHints().includes(String(gameId));
}

export function clearTrainerProjectHint(gameId) {
  if (!gameId) return;

  const id = String(gameId);
  const hints = readTrainerProjectHints().filter((hintId) => hintId !== id);
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(hints));
}
